import { render } from "./modal-instant-booking-confirmation.vue?vue&type=template&id=53eb2a00&scoped=true&ts=true"
import script from "./modal-instant-booking-confirmation.vue?vue&type=script&lang=ts"
export * from "./modal-instant-booking-confirmation.vue?vue&type=script&lang=ts"

import "./modal-instant-booking-confirmation.vue?vue&type=style&index=0&id=53eb2a00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eb2a00"]])

export default __exports__